import { render, staticRenderFns } from "./SocialFusionEmbed.vue?vue&type=template&id=3359e4a0"
import script from "./SocialFusionEmbed.vue?vue&type=script&lang=js"
export * from "./SocialFusionEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports